import React, { useEffect, useState }  from 'react';
import {connect} from 'react-redux';
import axios from 'axios';
import ActivateMFA from '../ui-componets/accounts-profile/activate-mfa';
import BreadCrumbs from "../ui-componets/breadcrumbs";
import { getProfileData, postProfileData } from '../modules/details.ducks';
import {credentialChangeLogout} from "../modules/join.ducks";
import Loader from '../ui-componets/loader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Back from "../ui-componets/Back";
import { useTranslation } from 'react-i18next';
import { useTokenAuth } from '../hooks/useTokenAuth';

interface IProps {
    loginDetails: any
    epAPI: any
    history: any
    tokenDetails:any
    global:any
    credentialChangeLogout: any
    dieselCardUser?: boolean
    shopUser?: boolean
}

function EnableMFA(props: IProps) {
    const { t } = useTranslation();
    const [isLoader, setIsLoader] = useState(false);
    const { credentialChangeLogout } = props;
    const notify = (msg: any) => toast.success(msg, {
        position: "top-right",
        closeButton: false,
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        className: "taost-bg-green",
        icon: ({}) =>  <img src="/profile/static/toast-tick.svg"/>
    });

    const errNotify = (msg: any) => toast.error(msg, {
        position: "top-right",
        closeButton: false,
        autoClose: 4000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        className: "taost-bg-red",
    });  

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // Use reusable token authentication hook
    useTokenAuth('/profile/details', props.global, props.tokenDetails, props.history);

    const sections = [
        { key: 'Home', content: t('Your Account'), className: 'parent-breadcrumbs font-styleLight', href: '/account', link: true },
        { key: 'enable-mfa', className: 'child-breadcrumbs font-styleLight', content: t('Two-Step Verification'), link: false },
    ]
    const { epAPI, loginDetails } = props;

    const handleEnableMFA = (phoneNumber: string) => {
        axios({
            headers: {
                'Content-Type': 'application/json',
                Authorization: props.tokenDetails.access_token
            },
            withCredentials: true,
            method: 'PUT',
            url: `${epAPI}/api/user-authentication/enable-mfa`,
            data: { phone: phoneNumber }
        })
        .then(function (response:any) {
            notify('Success. You will be logged out of your account to set up Two-Step Authentication.!');
            setTimeout(() => {
                setIsLoader(true);
                credentialChangeLogout()
            }, 2000)
        })
        .catch(function (error) {
            if (error.response) {
                errNotify(error.response.data.message);
            } 
        });
    }

    return (
        <div>
            { isLoader ?
                <div>
                    <Loader/>
                </div>:
                <div className="AccountsProfile-layout">
                    <ToastContainer />
                    <div className="AccountsProfile-acc-page">
                        <div className="maximising-the-width">
                            {
                                props.shopUser && <div className="dropdown-for-activity dropdown-for-order pt-0 pl-5">
                                    <Back
                                        refreshToken={props.tokenDetails.refresh_token}
                                        dieselCardUser={props.dieselCardUser}/>
                                </div>
                            }
                            <div className="page-heads-title-for-all-accounts">
                                <div className="page-heads-title-for-all-accounts-img">
                                    <img src="/profile/static/your-deatils-main.svg" />
                                </div>
                                <div className="page-heads-title-for-all-accounts-content">
                                    <p className="m-0 font-styleBold">{t('Two-Step Verification')}</p>
                                </div>
                                {sections.length > 0 && !props.shopUser ? <BreadCrumbs
                                    sections={sections}
                                    handleClick={(url: string) => props.history.push(url)}
                                    backAction={() => props.history.goBack()} />
                                    : null}
                            </div>
                            
                            <ActivateMFA
                            mfaStatus={loginDetails?.mfaStatus}
                            onMFAEnableSave={data => handleEnableMFA(data)}
                            />
                        </div>
                    </div>
                </div>
            }
        </div>
    );
}


const mapStateToProps = (state: any) => ({
    tokenDetails: state.join.tokens,
    loginDetails: state.join.loginDetails,
    epAPI: state.global.EP_ADMIN_URL,
});

export default connect(mapStateToProps, {getProfileData, postProfileData, credentialChangeLogout})(EnableMFA);